import { createClient } from '@supabase/supabase-js'
import ENV from "@/env"

const supabaseUrl = 'https://kzmzniagsfcfnhgsjkpv.supabase.co'
const supabaseKey = ENV.VITE_SUPABASE_KEY

export const supabase = createClient(supabaseUrl, supabaseKey)
